import isModifierSet, { setModifier } from "@/functions/userModifier";
import { ModifierType } from "@/functions/userModifierEnum";
import { computed } from "vue";
export const isLISA3 = computed({
  get() {
    return isModifierSet(ModifierType.LISA3);
  },
  set(v: boolean) {
    setModifier(ModifierType.LISA3, v, { updateStore: true });
  },
});
